import React from "react";
import ReactMarkdown from "react-markdown";

import { getAttemptedChallengeTableDefinition } from "../res/TableConfig";
import {
  Badge,
  Button,
  Spinner,
  Table,
  ColumnLayout,
  Icon,
  Alert,
  Flash,
} from "@amzn/awsui-components-react/polaris";

import { saveAs } from "../helpers/FileSaver";

import * as actionCreators from "../res/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import axios from "../res/axios";
import { connect as mqttConnect } from "mqtt";

import countdown from "../helpers/countdown";

import {
  newScoringSystemWarning,
  newScoringSystemWarningDisabledObject,
} from "../res/constants";

const mapStateToProps = (state) => {
  return {
    user:
      state.appState && state.appState.user ? state.appState.user : "nobody",
    serverClientTimeOffset: state.appState.serverClientTimeOffset,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      addNotification: actionCreators.addNotification,
      clearSingleNotification: actionCreators.clearSingleNotification,
    },
    dispatch
  );
};

function getRandomInt(max = 100) {
  return Math.floor(Math.random() * Math.floor(max));
}

class Credentials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      credentials: null,
    };
    this.downloadFile = this.downloadFile.bind(this);
  }

  downloadFile(data, filename) {
    try {
      var isFileSaverSupported = !!new Blob();
      if (isFileSaverSupported) {
        var blob = new Blob([data], {
          type: "application/x-pem-file;charset=utf-8",
        });
        saveAs(blob, filename);
      } else {
        alert(
          "Could not download file. Please use the latest version of Chrome/Firefox/Safari"
        );
      }
    } catch (e) {
      console.log("Could not download file. Error: ", e);
      alert(
        "Could not download file. Please use the latest version of Chrome/Firefox/Safari"
      );
    }
  }

  render() {
    var data;
    try {
      data = this.props.data;
    } catch (error) {
      console.log("Could not parse JSON");
    }
    if (!data) {
      return <Spinner size="large"></Spinner>;
    }
    return (
      <div>
        <div className="awsui-util-container">
          <div className="awsui-util-container-header">
            <h2>Credentials</h2>
          </div>
          <ColumnLayout columns={2} variant="text-grid">
            <div data-awsui-column-layout-root="true">
              {data.map((credential, index) => {
                return (
                  // <li key={index}>{credential.OutputKey}</li>
                  <div key={index}>
                    <div className="awsui-util-spacing-v-s">
                      <div>
                        <div className="awsui-util-label">
                          {credential.OutputKey}
                        </div>
                        {credential.OutputKey === "ConsoleAccessURL" ? (
                          <a
                            href={credential.OutputValue.replace(/["']/g, "")}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {credential.OutputValue.replace(/["']/g, "")}{" "}
                            <Icon name="external" />
                          </a>
                        ) : credential.OutputKey === "InstanceIPAddress" ? (
                          <a
                            href={"https://" + credential.OutputValue}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {credential.OutputValue} <Icon name="external" />
                          </a>
                        ) : credential.OutputKey === "InstancePrivateKey" ? (
                          <a
                            onClick={() => {
                              this.downloadFile(
                                credential.OutputValue,
                                "privatekey.pem"
                              );
                            }}
                          >
                            {" "}
                            Click here to download{" "}
                          </a>
                        ) : (
                          <div>{credential.OutputValue}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </ColumnLayout>
        </div>
      </div>
    );
  }
}

class Hint extends React.Component {
  // props: getHint(), hint, hintAccessed, hintLoading
  render() {
    return (
      <div className="awsui-util-container">
        <div className="awsui-util-container-header">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <h2>{this.props.hint.title}</h2>
            <Button
              variant="normal"
              onClick={this.props.getHint}
              disabled={this.props.hintAccessed}
              loading={this.props.hintLoading}
            >
              <p>Access Hint</p>
            </Button>
          </div>
          <p>
            <b>
              {"Note: you will lose " +
                this.props.hint.cost +
                " points to access this hint!"}
            </b>
          </p>
        </div>
        {this.props.hintAccessed && (
          <div>
            <ReactMarkdown source={this.props.hint.content} />
          </div>
        )}
      </div>
    );
  }
}

class IndividualChallenge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      provisioning: false,
      challenge: null,
      attempts: [],
      ongoingAttempt: null,
      loading: true,
      url: null,
      errorMessage: null,
      startAttemptButtonLoading: false,
      scoringSystemAlertDisabled: false,
      hint1Loading: false,
      hint2Loading: false,
      blocked: false,
    };

    this.timerId = 0;
    this.expiryNotification = null;

    this.startProvision = this.startProvision.bind(this);
    this.mqttSubscribe = this.mqttSubscribe.bind(this);
    this.provisioningComplete = this.provisioningComplete.bind(this);
    this.validationComplete = this.validationComplete.bind(this);
    this.finishAttempt = this.finishAttempt.bind(this);
    this.startAttempt = this.startAttempt.bind(this);
    this.loadItems = this.loadItems.bind(this);
    this.refresh = this.refresh.bind(this);
    this.getHint = this.getHint.bind(this);
    this.timerRef = React.createRef();

    // TODO: Changes made to accommodate the initial stages of onboarding to the new scoring system.
    //  Would be removed after all challenges are updated with the newer scoring criteria
    this.newScoringSystemAlert = this.newScoringSystemAlert.bind(this);
    this.isScoringSystemAlertDisabled =
      this.isScoringSystemAlertDisabled.bind(this);
    this.permanentlyDisableScoringSystemAlert =
      this.permanentlyDisableScoringSystemAlert.bind(this);
  }

  refresh() {
    this.setState({
      loading: true,
    });
    this.loadItems();
  }

  componentDidMount() {
    this.setState({
      url: window.location.href,
    });
    this.loadItems();
    if (this.isScoringSystemAlertDisabled()) {
      this.setState({
        scoringSystemAlertDisabled: true,
      });
    } else {
      this.setState({
        scoringSystemAlertDisabled: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = 0;
    }
  }

  componentDidUpdate() {
    var self = this;
    if (
      this.state &&
      this.state.ongoingAttempt &&
      this.state.ongoingAttempt.attemptStatus === "ATTEMPT_IN_PROGRESS" &&
      this.timerRef &&
      this.timerRef.current &&
      this.state.ongoingAttempt.challengeEndTime
    ) {
      let challengeEndTimestamp =
        parseInt(this.state.ongoingAttempt.challengeEndTime, 10) +
        this.props.serverClientTimeOffset;
      var timerId = countdown(
        function (ts) {
          if (
            !self ||
            !self.timerRef ||
            !self.timerRef.current ||
            !self.timerRef.current.innerHTML
          ) {
            if (self.timerId) {
              window.clearInterval(self.timerId);
              self.timerId = 0;
            }
            return;
          }
          self.timerRef.current.innerHTML = ts.toHTML();
          if (ts.value < 1000) {
            self.timerRef.current.innerHTML = "Time's up!";
            console.log("finishing attempt");
            let notification = {
              id: self.state.challenge.challengeId,
              type: "info",
              dismissible: false,
              visible: true,
              header: "Attempting to finish the ongoing attempt.",
              content: "Please wait...",
              buttonText: "",
              loading: true,
              autoHide: false,
            };
            self.props.clearSingleNotification(
              self.state.challenge.challengeId
            );
            self.props.addNotification(notification);
            self.finishAttempt();
          }
        },
        challengeEndTimestamp,
        countdown.HOURS | countdown.MINUTES | countdown.SECONDS
      );
      this.timerId = timerId;
    }
  }

  loadItems() {
    var user = this.props.user;
    if (user === "nobody") {
      return;
    }

    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = 0;
    }
    let headers = {
      "x-csrf-token": localStorage.getItem("BOTSE_SESSION_TOKEN"),
      Action: "Challenge:DescribeChallenge",
    };
    axios
      .post(
        "action",
        {
          params: {
            challengeId: this.props.match.params.challengeId,
            domainId: this.props.match.params.domainId,
          },
        },
        { headers: headers }
      )
      .then((res) => {
        this.props.clearSingleNotification(this.props.match.params.challengeId);
        res.data = JSON.parse(res.data);
        const errorCode = res.data.error.code ? res.data.error.code : null;
        // As of today, the possible error codes coming up from the DescribeChallenge API is:
        // > 500 for a code logic/DDB API call issue
        // > 404 if the challenge is not found or an invalid domain mapping is supplied in the URL
        // > 202 if there are no attempts found for the challenge
        // For now, we should only action on 404 and 500 status codes
        if (errorCode && parseInt(errorCode, 10) >= 300) {
          // If the error code matches, bail out
          let errorMessage = res.data.error.message;
          let errorState = {
            loading: false,
            errorMessage: errorMessage,
          };
          this.setState(errorState);
          return;
        }
        const challenge = res.data.data.challenge[0];
        const attempts = res.data.data.lastFiveAttempts;
        const ongoingAttempt = res.data.data.ongoingAttempt;
        challenge.prerequisites = JSON.parse(challenge.prerequisites);
        challenge.description = JSON.parse(challenge.description);
        var state = {
          loading: false,
          challenge: challenge,
          attempts: attempts,
          ongoingAttempt: ongoingAttempt,
        };

        //check if challenge has been blocked or has been deleted, if so, shows the notification banner to let the user know
        // isActive = 1 -> challenge is active and can be provisioned by user
        // isActive = 0 -> challenge is blocked automatically due to high failure rate
        // isActive = -1 -> challenge has been redeployed to beta manually
        switch (parseInt(challenge.isActive, 10)) {
          case 1:
            this.setState({ blocked: false });
            this.props.clearSingleNotification(challenge.challengeId);
            break;
          case 0:
            let notification = {
              id: challenge.challengeId,
              type: "error",
              dismissible: true,
              header: "Challenge has been blocked!",
              content: (
                <div>
                  <p>
                    This challenge has been blocked due to high failure rate, so
                    please do not provision this challenge at this point. If you
                    find this challenge still blocked after three days, please
                    click report issue button in this page to notify bottlenose
                    team.
                  </p>
                  <p>
                    Note: Please search in this{" "}
                    <a
                      href={`https://sim.amazon.com/issues/search?q=status%3A(Open)+containingFolder%3A(696e11d4-d6af-451a-b534-27a6b196b443)+description%3A(${challenge.challengeId})&sort=lastUpdatedConversationDate+desc`}
                      target="_blank"
                    >
                      SIM folder
                    </a>{" "}
                    for existing ticket for this challenge before cutting a new
                    one.
                  </p>
                </div>
              ),
            };
            this.props.clearSingleNotification(challenge.challengeId);
            this.props.addNotification(notification);
            this.setState({ blocked: true });
            break;
          case -1:
            this.setState({
              errorMessage:
                "This challenge is not available as it has either been removed from prod for issue fix or has been deleted permanently. Please ignore this challenge.",
            });
            break;
          default:
            console.warn(
              "challenge status received is not one of the expected values (1, 0, -1), status received: " +
                challenge.isActive
            );
        }

        // check if ongoingAttempt is empty {}
        var noOngoingAttempt = !Object.keys(ongoingAttempt).length;
        // to check if provision completed
        var provision_complete = false;
        // if there is an ongoing attempt, and the ongoing attempt object has stackState key
        if (!noOngoingAttempt && ongoingAttempt.stackState) {
          console.log("found ongoing attempt");
          if (ongoingAttempt.attemptStatus === "PROVISION_IN_PROGRESS") {
            state.provisioning = true;
            state.attempts = [ongoingAttempt, ...state.attempts];
            // state.ongoingAttempt.notificationID = getRandomInt();
            let notification = {
              id: state.challenge.challengeId,
              type: "info",
              dismissible: false,
              visible: true,
              header: "Provisioning resources",
              content:
                "Please wait while necessary resources to start this challenge are being provisioned. It might take around 30 miniutes depending on the resources involved.",
              buttonText: "",
              loading: true,
              autoHide: false,
            };

            this.props.clearSingleNotification(state.challenge.challengeId);
            this.props.addNotification(notification);

            if (ongoingAttempt.mqttSignedUrl && ongoingAttempt.attemptId) {
              this.mqttSubscribe(
                challenge,
                ongoingAttempt.mqttSignedUrl,
                "/" + ongoingAttempt.attemptId
              );
            }
          } else if (
            ongoingAttempt.attemptStatus === "VALIDATION_IN_PROGRESS"
          ) {
            state.provisioning = false;
            state.attempts = [ongoingAttempt, ...state.attempts];
            let notification = {
              id: state.challenge.challengeId,
              type: "info",
              dismissible: false,
              visible: true,
              header: "Generating score for attempt",
              content:
                "Please refresh the page if validation takes more than 5 minutes to complete",
              buttonText: "",
              loading: true,
              autoHide: false,
            };
            this.props.clearSingleNotification(state.challenge.challengeId);
            this.props.addNotification(notification);

            if (ongoingAttempt.mqttSignedUrl && ongoingAttempt.attemptId) {
              this.mqttSubscribe(
                challenge,
                ongoingAttempt.mqttSignedUrl,
                "/" + ongoingAttempt.attemptId
              );
            }
          } else if (ongoingAttempt.attemptStatus === "PROVISION_COMPLETE") {
            provision_complete = true;
            state.attempts = [ongoingAttempt, ...state.attempts];
            state.provisioning = false;
          } else if (ongoingAttempt.attemptStatus === "ATTEMPT_IN_PROGRESS") {
            state.attempts = [ongoingAttempt, ...state.attempts];
            state.provisioning = false;
          } else {
            state.provisioning = false;
          }
        }
        this.setState(state);
        if (provision_complete) this.provisioningComplete(challenge);
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
          challenge: null,
          attempts: [],
          provisioning: false,
          ongoingAttempt: null,
        });

        let notification = {
          id: getRandomInt(),
          type: "error",
          dismissible: true,
          header: "Failed to fetch challenge and/or attempts!",
          content:
            "Please check your internet connectivity and reload the page.",
        };
        this.props.addNotification(notification);
      });
  }

  mqttSubscribe(challenge, mqttSignedUrl, mqttSubscribeTopic) {
    var self = this;

    //start-testconn
    let mqttClient = mqttConnect(mqttSignedUrl);

    mqttClient.on("connect", function () {
      mqttClient.subscribe(mqttSubscribeTopic);
    });
    mqttClient.on("message", function (topic, message) {
      message = JSON.parse(message.toString());
      let stackState = message.stackState;
      if (stackState === "PROVISION_COMPLETE") {
        self.provisioningComplete(challenge);
        try {
          mqttClient.end();
          console.log("Disconnected from MQTT broker");
        } catch (error) {
          console.log("MQTT Disconnect error");
        }
      } else if (stackState === "PROVISION_FAILED") {
        self.provisioningFailed(challenge);
        try {
          mqttClient.end();
          console.log("Disconnected from MQTT broker");
        } catch (error) {
          console.log("MQTT Disconnect error");
        }
      } else if (
        stackState === "VALIDATION_COMPLETE" ||
        stackState === "VALIDATION_FAILED"
      ) {
        let score = {};
        if (stackState === "VALIDATION_COMPLETE") {
          score = message.score;
        }
        self.validationComplete(challenge, stackState, score);
        try {
          mqttClient.end();
          console.log("Disconnected from MQTT broker");
        } catch (error) {
          console.log("MQTT Disconnect error");
        }
      }
    });
  }

  startProvision() {
    const self = this;
    const challenge = this.state.challenge;
    const challengeId = challenge.challengeId;

    this.setState({
      provisioning: true,
    });

    let notification = {
      id: challengeId,
      type: "info",
      dismissible: false,
      visible: true,
      header: "Loading...",
      content: "Please wait.",
      buttonText: "",
      loading: true,
    };
    this.props.clearSingleNotification(challengeId);
    this.props.addNotification(notification);

    let headers = {
      "x-csrf-token": localStorage.getItem("BOTSE_SESSION_TOKEN"),
      Action: "Attempt:ProvisionResources",
    };
    axios
      .post(
        "action",
        {
          params: {
            challengeId: this.props.match.params.challengeId,
            domainId: this.props.match.params.domainId,
          },
        },
        { headers: headers }
      )
      .then((provisionRes) => {
        //get the error code response here and notify accordingly, if no error code, then continue normally
        let parsedProvisionRes = JSON.parse(
          provisionRes.data.replace(/'/g, '"')
        );
        if (
          parsedProvisionRes.error.code === "500" ||
          parsedProvisionRes.error.code === "400"
        ) {
          let provisionErrorNotification = {
            id: challengeId,
            type: "error",
            dismissible: true,
            header: "Failed to provision resources!",
            content: `${
              parsedProvisionRes.error.message
                ? parsedProvisionRes.error.message
                : "Error"
            }`,
          };
          self.props.clearSingleNotification(challengeId);
          self.props.addNotification(provisionErrorNotification);
          this.setState({
            provisioning: false,
          });
        } else {
          //apparently provisioning call was fine, let's go ahead
          provisionRes.data = JSON.parse(provisionRes.data.replace(/'/g, '"'));
          var attemptId =
            provisionRes.data &&
            provisionRes.data.data &&
            provisionRes.data.data.attemptId
              ? provisionRes.data.data.attemptId
              : undefined;
          var mqttSignedUrl =
            provisionRes.data &&
            provisionRes.data.data &&
            provisionRes.data.data.signedMqttUrl
              ? provisionRes.data.data.signedMqttUrl
              : undefined;
          var mqttSubscribeTopic = "/" + attemptId;

          var newAttempt = {
            attemptId: attemptId,
            attemptStatus: "PROVISION_IN_PROGRESS",
          };

          this.setState({
            attempts: [newAttempt, ...self.state.attempts],
            ongoingAttempt: newAttempt,
          });

          var successNotification = {
            id: challengeId,
            type: "info",
            dismissible: false,
            visible: true,
            header: "Started resource provisioning",
            content:
              "Please wait while necessary resources to start this challenge are being provisioned. It might take around 30 minutes depending on the resources involved. If challenge is still in the progress of resource provisioning after 30 mins, please refresh the page.",
            buttonText: "",
            loading: true,
          };
          this.props.clearSingleNotification(challengeId);
          this.props.addNotification(successNotification);

          this.mqttSubscribe(challenge, mqttSignedUrl, mqttSubscribeTopic);

          // TODO - add to attempts array of state (after verifying no going attempts in this.state.attempts[] array and this.state.ongoingAttempt is null)
        }
      })
      .catch((provisionErr) => {
        let notification = {
          id: challengeId,
          type: "error",
          dismissible: true,
          header:
            "Failed to provision resources! Please check you connectivity and try again. Report an issue if you see this repeateadly",
          content: `${
            provisionErr.response &&
            provisionErr.response.data &&
            provisionErr.response.data.message
              ? provisionErr.response.data.message
              : provisionErr.message
              ? provisionErr.message
              : "Error"
          }`,
        };
        self.props.clearSingleNotification(challengeId);
        self.props.addNotification(notification);
      });
  }

  provisioningFailed(challenge) {
    this.props.clearSingleNotification(challenge.challengeId);
    var ongoingAttempt = this.state.ongoingAttempt;
    ongoingAttempt.attemptStatus = "PROVISION_FAILED";

    var attempts = this.state.attempts;
    attempts = attempts.filter(
      (attempt) => attempt.attemptId !== ongoingAttempt.attemptId
    );

    this.setState({
      provisioning: false,
      attempts: [ongoingAttempt, ...attempts],
      ongoingAttempt: {},
    });
    let notification = {
      id: challenge.challengeId,
      type: "error",
      dismissible: true,
      visible: true,
      header: "Resources failed to provision.",
      content:
        "Please try again in sometime. Report an issue if you see this repeateadly",
      loading: false,
      autoHide: false,
    };
    this.props.clearSingleNotification(challenge.challengeId);
    this.props.addNotification(notification);
  }

  provisioningComplete(challenge) {
    this.props.clearSingleNotification(challenge.challengeId);
    var ongoingAttempt = this.state.ongoingAttempt;
    ongoingAttempt.attemptStatus = "PROVISION_COMPLETE";

    var attempts = this.state.attempts;
    attempts = attempts.filter(
      (attempt) => attempt.attemptId !== ongoingAttempt.attemptId
    );

    this.setState({
      provisioning: false,
      attempts: [ongoingAttempt, ...attempts],
      ongoingAttempt: ongoingAttempt,
    });
    let notification = {
      id: challenge.challengeId,
      type: "success",
      dismissible: true,
      visible: true,
      header: "Resources provisioned successfully",
      content:
        "You can now start the challenge! The necessary resources to start this challenge have been provisioned successfully.",
      loading: false,
      autoHide: false,
    };
    this.props.clearSingleNotification(challenge.challengeId);
    this.props.addNotification(notification);
  }

  validationComplete(challenge, attemptStatus, score) {
    if (attemptStatus === "VALIDATION_COMPLETE") {
      console.log(
        "Validation complete. Score obtained = " + JSON.stringify(score)
      );
    } else {
      console.error("Validation failed");
    }
    this.props.clearSingleNotification(challenge.challengeId);
    let completedAttempt = { ...this.state.ongoingAttempt };
    completedAttempt.attemptStatus = attemptStatus;
    if (attemptStatus === "VALIDATION_COMPLETE") {
      completedAttempt.score = score;
    }

    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = 0;
    }

    let attempts = this.state.attempts;
    attempts = attempts.filter(
      (attempt) => attempt.attemptId !== completedAttempt.attemptId
    );

    this.setState({
      provisioning: false,
      attempts: [completedAttempt, ...attempts],
      ongoingAttempt: {},
    });
    let notification = {
      id: challenge.challengeId,
      type: "success",
      dismissible: true,
      visible: true,
      header: "Validation complete.",
      content:
        "Your attempt has been graded. Check the attempts section below to know your score.",
      loading: false,
      autoHide: false,
    };
    if (attemptStatus === "VALIDATION_FAILED") {
      notification.type = "error";
      notification.content =
        "Validation failed as unhandled error happened during validation process!";
    }
    this.props.clearSingleNotification(challenge.challengeId);
    this.props.addNotification(notification);
  }

  startAttempt() {
    const challengeId = this.state.challenge.challengeId;
    const attemptId = this.state.ongoingAttempt
      ? this.state.ongoingAttempt.attemptId
      : undefined;

    this.setState({ startAttemptButtonLoading: true });

    let notification = {
      id: challengeId,
      type: "info",
      dismissible: false,
      visible: true,
      header: "Loading...",
      content: "Please wait.",
      buttonText: "",
      loading: true,
    };

    if (!challengeId || !attemptId) {
      notification = {
        id: challengeId ? challengeId : getRandomInt(),
        type: "error",
        dismissible: true,
        header: "Failed to start attempt.",
        content:
          "Missing challengeID and/or attempt ID. Please try again later.",
      };
      this.props.addNotification(notification);
      return;
    }

    this.props.clearSingleNotification(challengeId);
    this.props.addNotification(notification);

    let headers = {
      "x-csrf-token": localStorage.getItem("BOTSE_SESSION_TOKEN"),
      Action: "Attempt:StartAttempt",
    };
    axios
      .post(
        "action",
        { params: { attemptId: attemptId } },
        { headers: headers }
      )
      .then((res) => {
        res.data = JSON.parse(res.data);

        // Check if the attempt has expired
        const error = res.data
          ? res.data.error
            ? res.data.error
            : undefined
          : undefined;
        if (error) {
          let notification = {
            id: challengeId,
            type: "error",
            dismissible: true,
            header: "Attempt has expired",
            content: res.data.message,
          };
          this.props.clearSingleNotification(challengeId);
          this.props.addNotification(notification);
          this.setState({ startAttemptButtonLoading: false });
          return;
        }

        const challengeStartTime = res.data
          ? res.data.data
            ? res.data.data.challengeStartTime
              ? res.data.data.challengeStartTime
              : undefined
            : undefined
          : undefined;
        const challengeEndTime = res.data
          ? res.data.data
            ? res.data.data.challengeEndTime
              ? res.data.data.challengeEndTime
              : undefined
            : undefined
          : undefined;
        const credentials = res.data
          ? res.data.data
            ? res.data.data.credentials
              ? res.data.data.credentials
              : undefined
            : undefined
          : undefined;

        if (!challengeStartTime || !challengeEndTime || !credentials) {
          let notification = {
            id: challengeId,
            type: "error",
            dismissible: true,
            header: "Failed to start attempt.",
            content:
              "Could not determining challenge start/end time or credentials. Please try again later.",
          };
          this.props.clearSingleNotification(challengeId);
          this.props.addNotification(notification);
          this.setState({ startAttemptButtonLoading: false });
          return;
        }

        let notification = {
          id: challengeId,
          type: "success",
          dismissible: true,
          visible: true,
          header: "Started attempt",
          content: res.data.message,
          buttonText: "",
          loading: false,
          autoHide: false,
        };

        this.props.clearSingleNotification(challengeId);
        this.props.addNotification(notification);

        var ongoingAttempt = Object.assign({}, this.state.ongoingAttempt);
        ongoingAttempt.attemptStatus = "ATTEMPT_IN_PROGRESS";
        ongoingAttempt.challengeStartTime = challengeStartTime;
        ongoingAttempt.challengeEndTime = challengeEndTime;
        ongoingAttempt.credentials = credentials;
        ongoingAttempt.hint1Accessed = false;
        ongoingAttempt.hint2Accessed = false;

        var attempts = this.state.attempts;
        attempts = attempts.filter(
          (attempt) => attempt.attemptId !== ongoingAttempt.attemptId
        );

        this.setState({
          startAttemptButtonLoading: false,
          attempts: [ongoingAttempt, ...attempts],
          ongoingAttempt: ongoingAttempt,
        });
      })
      .catch((err) => {
        console.log("Err", err);

        let notification = {
          id: getRandomInt(),
          type: "error",
          dismissible: true,
          header: "Failed to start attempt.",
          content: "Bad Request. Please try again later.",
        };

        this.props.addNotification(notification);
      });
  }

  finishAttempt() {
    console.log("Finish attempt called");
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = 0;
    }
    let ongoingAttempt = { ...this.state.ongoingAttempt };
    ongoingAttempt.attemptStatus = "VALIDATION_IN_PROGRESS";
    let attempts = this.state.attempts;
    attempts = attempts.filter(
      (attempt) => attempt.attemptId !== ongoingAttempt.attemptId
    );

    this.setState({
      attempts: [ongoingAttempt, ...attempts],
      ongoingAttempt: ongoingAttempt,
    });

    const challenge = this.state.challenge;
    const challengeId = challenge.challengeId;
    const attemptId = this.state.ongoingAttempt.attemptId;

    let attemptEndNotification = {
      id: challengeId,
      type: "info",
      dismissible: false,
      visible: true,
      header: "Finishing up attempt",
      content: "Please wait...",
      buttonText: "",
      loading: true,
      autoHide: false,
    };

    this.props.clearSingleNotification(challengeId);
    this.props.addNotification(attemptEndNotification);
    let headers = {
      "x-csrf-token": localStorage.getItem("BOTSE_SESSION_TOKEN"),
      Action: "Attempt:FinishAttempt",
    };
    axios
      .post(
        "action",
        {
          params: {
            attemptId: attemptId,
            challengeId: this.props.match.params.challengeId,
            domainId: this.props.match.params.domainId,
          },
        },
        { headers: headers }
      )
      .then((finishRes) => {
        finishRes.data = JSON.parse(finishRes.data);
        //check if any error code was returned from backend
        if (
          finishRes.data.error.code &&
          parseInt(finishRes.data.error.code, 10) >= 400
        ) {
          let failNotification = {
            id: challengeId,
            type: "error",
            dismissible: "true",
            header: "Fail to start the validation process",
            content:
              "Error when trying to initiate the validation process for current attempt. Please refresh the page and try again. If issue still exist, please report the issue to bottlenose team through SIM ticket.",
            autoHide: false,
          };
          this.props.clearSingleNotification(challengeId);
          this.props.addNotification(failNotification);
          return;
        }

        let mqttSignedUrl = finishRes.data.data.mqttSignedUrl;

        let successNotification = {
          id: challengeId,
          type: "info",
          dismissible: false,
          visible: true,
          header: "Generating score for attempt",
          content:
            "Validation in progress. Please refresh the page if validation takes more than 5 minutes to complete",
          buttonText: "",
          loading: true,
          autoHide: false,
        };
        this.props.clearSingleNotification(challengeId);
        this.props.addNotification(successNotification);
        this.mqttSubscribe(challenge, mqttSignedUrl, "/" + attemptId);
      })
      .catch((finishErr) => {
        console.log("Failed to finish attempt. Error: ", finishErr);
        let notification = {
          id: challengeId,
          type: "error",
          dismissible: true,
          header: "Failed to finish attempt.",
          content: `${
            finishErr.response &&
            finishErr.response.data &&
            finishErr.response.data.message
              ? finishErr.response.data.message
              : finishErr.message
              ? finishErr.message
              : "Error"
          }`,
        };
        this.props.clearSingleNotification(challengeId);
        this.props.addNotification(notification);
        let attempt = { ...this.state.ongoingAttempt };
        attempt.attemptStatus = "ATTEMPT_IN_PROGRESS";
        this.setState({ ongoingAttempt: attempt });
      });
  }

  // TODO: Changes made to accommodate the initial stages of onboarding to the new scoring system.
  //  Would be removed after all challenges are updated with the newer scoring criteria
  newScoringSystemAlert() {
    return (
      <Alert
        header="New scoring system alert"
        buttonText="Dismiss this message permanently"
        dismissible={true}
        visible={!this.state.scoringSystemAlertDisabled}
        onButtonClick={(event) => this.permanentlyDisableScoringSystemAlert()}
      >
        <div className="awsui-util-d-ib">{newScoringSystemWarning}</div>
      </Alert>
    );
  }

  permanentlyDisableScoringSystemAlert() {
    this.setState({ scoringSystemAlertDisabled: true });
    // Set this value in session storage, will be read on componentDidMount block
    sessionStorage.setItem(newScoringSystemWarningDisabledObject, "true");
  }

  isScoringSystemAlertDisabled() {
    return !!sessionStorage.getItem(newScoringSystemWarningDisabledObject);
  }
  // TODO: End new scoring system changes

  getHint(hintId) {
    let attemptId = this.state.ongoingAttempt.attemptId;
    let challengeId = this.state.challenge.challengeId;
    if (hintId === 1) {
      this.setState({ hint1Loading: true });
    } else {
      this.setState({ hint2Loading: true });
    }
    let headers = {
      "x-csrf-token": localStorage.getItem("BOTSE_SESSION_TOKEN"),
      Action: "Attempt:GetHint",
    };
    axios
      .post(
        "action",
        {
          params: {
            attemptId: attemptId,
            challengeId: challengeId,
            hintId: hintId,
          },
        },
        { headers: headers }
      )
      .then((res) => {
        let data = JSON.parse(res.data);
        let resultCode = data.code;
        if (resultCode && parseInt(resultCode, 10) > 300) {
          //failed to get hint from backend
          console.error(
            "failed to get hint from backend, status code: " +
              resultCode +
              " error message: " +
              data.error
          );
          let notification = {
            id: challengeId,
            type: "error",
            dismissible: true,
            header: "Failed to access hint content",
            content: data.message,
          };
          this.props.clearSingleNotification(challengeId);
          this.props.addNotification(notification);
          if (hintId === 1) {
            this.setState({ hint1Loading: false });
          } else {
            this.setState({ hint2Loading: false });
          }
          return;
        }
        let hintContent = data.hint;
        let ongoingAttempt = Object.assign({}, this.state.ongoingAttempt);
        let previousAttempts = this.state.attempts.filter(
          (attempt) => attempt.attemptId !== ongoingAttempt.attemptId
        );
        let challenge = Object.assign({}, this.state.challenge);
        if (hintId === 1) {
          ongoingAttempt.hint1Accessed = true;
          challenge.hint1.content = hintContent;
        } else {
          ongoingAttempt.hint2Accessed = true;
          challenge.hint2.content = hintContent;
        }
        this.setState({
          attempts: [ongoingAttempt, ...previousAttempts],
          ongoingAttempt: ongoingAttempt,
          challenge: challenge,
        });
        if (hintId === 1) {
          this.setState({ hint1Loading: false });
        } else {
          this.setState({ hint2Loading: false });
        }
      })
      .catch((err) => {
        console.error("Error when accessing hint: " + err);
        let notification = {
          id: getRandomInt(),
          type: "error",
          dismissible: true,
          header: "Failed to access hint content",
          content: "Hint Access API call failed",
        };
        this.props.addNotification(notification);
        if (hintId === 1) {
          this.setState({ hint1Loading: false });
        } else {
          this.setState({ hint2Loading: false });
        }
      });
  }

  render() {
    if (this.state.loading || this.props.user === "nobody") {
      return <Spinner size="large"></Spinner>;
    } else if (this.state.errorMessage) {
      // If there is a value of the "errorMessage" state, populate this Flash notification
      return (
        <Flash dismissible={false} type="error">
          {this.state.errorMessage}
        </Flash>
      );
    }

    var noOngoingAttempt = !Object.keys(this.state.ongoingAttempt).length;

    this.attemptStatusBadge = noOngoingAttempt ? (
      <Badge content="No ongoing attempt"></Badge>
    ) : this.state.ongoingAttempt.attemptStatus === "ATTEMPT_IN_PROGRESS" ? (
      <Badge content="Ongoing"></Badge>
    ) : this.state.ongoingAttempt.attemptStatus === "PROVISION_COMPLETE" ? (
      <Badge content="Waiting to start"></Badge>
    ) : this.state.ongoingAttempt.attemptStatus === "PROVISION_IN_PROGRESS" ? (
      <Badge content="Provisioning Resources"></Badge>
    ) : this.state.ongoingAttempt.attemptStatus === "VALIDATION_IN_PROGRESS" ? (
      <Badge content="Validating Solution"></Badge>
    ) : (
      <Badge content="Unknown"></Badge>
    );

    this.countdownElement = (
      <div className="awsui-util-container">
        <h2>Time Allotted</h2>
        <p>
          {parseFloat(this.state.challenge.timeAllotted / 60000).toFixed(2)}{" "}
          minutes
        </p>
      </div>
    );

    this.credentialsElement = <div></div>;
    this.hint1Element = <div></div>;
    this.hint2Element = <div></div>;

    // If no ongoing attempt, allow the user to start an attempt
    if (noOngoingAttempt) {
      this.button = (
        <Button
          text="Provision Resources"
          variant="primary"
          icon="lock-private"
          loading={this.state.provisioning}
          onClick={this.startProvision}
          disabled={this.state.blocked}
        ></Button>
      );
      this.expiryNotification = null;
    } else {
      // If there is an ongoing attempt and the resources are being provisioned,
      // prevent the user from clicking the start button again (convert it into a loading button)
      if (this.state.provisioning) {
        this.button = (
          <Button
            text="Provisioning resources"
            variant="primary"
            loading={true}
          ></Button>
        );
        this.expiryNotification = null;
      }

      // If there is an onging attempt and resource provisioning has been completed,
      // and if the user has started the challenge already, then allow him to finish the challenge.
      else if (
        this.state.ongoingAttempt.attemptStatus === "ATTEMPT_IN_PROGRESS"
      ) {
        this.button = (
          <Button
            text="Finish attempt"
            variant="primary"
            icon="status-stopped"
            onClick={this.finishAttempt}
          ></Button>
        );
        this.countdownElement = (
          <div className="awsui-util-container">
            <h2>Time Remaining</h2>
            <p ref={this.timerRef}>Loading...</p>
          </div>
        );
        this.credentialsElement = (
          <Credentials data={this.state.ongoingAttempt.credentials} />
        );
        if ("hint1" in this.state.challenge) {
          this.hint1Element = (
            <Hint
              getHint={() => this.getHint(1)}
              hintAccessed={this.state.ongoingAttempt.hint1Accessed}
              hint={this.state.challenge.hint1}
              hintLoading={this.state.hint1Loading}
            />
          );
        }
        if ("hint2" in this.state.challenge) {
          this.hint2Element = (
            <Hint
              getHint={() => this.getHint(2)}
              hintAccessed={this.state.ongoingAttempt.hint2Accessed}
              hint={this.state.challenge.hint2}
              hintLoading={this.state.hint2Loading}
            />
          );
        }
        this.expiryNotification = null;
      } else if (
        this.state.ongoingAttempt.attemptStatus === "VALIDATION_IN_PROGRESS"
      ) {
        this.button = (
          <Button
            text="Validating attempt"
            variant="primary"
            loading={true}
          ></Button>
        );
        this.expiryNotification = null;
      }
      // If there is an onging attempt and resource provisioning has been completed,
      // and if the user has not started the challenge, then allow him to start the challenge.
      // Value of attemptStatus will be "waiting".
      else if (
        this.state.ongoingAttempt.attemptStatus === "PROVISION_COMPLETE"
      ) {
        // this.provisioningComplete(this.state.challenge);
        this.button = (
          <Button
            text="Start Attempt"
            variant="primary"
            icon="unlocked"
            onClick={this.startAttempt}
            loading={this.state.startAttemptButtonLoading}
          ></Button>
        );
        this.expiryNotification = (
          <Alert
            header="Note"
            content="The attempt will expire if not started within 30 minutes"
          ></Alert>
        );
      } else {
        this.expiryNotification = null;
        // Do nothing
      }
    }

    return (
      <div>
        {/* TODO: Changes made to accommodate the initial stages of onboarding to the new scoring system. Would be removed after all challenges are updated with the newer scoring criteria */}
        {this.newScoringSystemAlert()}
        <br />
        <div className="awsui-grid">
          <div className="awsui-row">
            <div className="col-xxs-12 col-m-3 push-m-9">
              <div className="awsui-util-container">
                <div className="awsui-util-container-header">
                  <h2>
                    Resources{" "}
                    <Button
                      className="awsui-util-f-r"
                      text="Button"
                      variant="icon"
                      icon="refresh"
                      onClick={this.refresh}
                    ></Button>
                  </h2>
                </div>
                <div>
                  <h4>Challenge ID: {this.state.challenge.challengeId}</h4>
                  <h4>
                    Primary Owner :{" "}
                    <a
                      href={
                        "https://phonetool.amazon.com/users/" +
                        this.state.challenge.primaryOwner
                      }
                      target={"_blank"}
                    >
                      {" "}
                      {this.state.challenge.primaryOwner}
                    </a>{" "}
                  </h4>
                  <h4>Attempt status: {this.attemptStatusBadge}</h4>
                  <h4>
                    Difficulty Level : {this.state.challenge.difficultyLevel}
                  </h4>
                  <h4>
                    Passing Score :{" "}
                    {this.state.challenge.passPercentage === undefined
                      ? "-"
                      : this.state.challenge.passPercentage}
                  </h4>
                  <br />
                  {this.button}
                </div>
                <div className="awsui-util-container-footer">
                  {this.countdownElement}
                </div>
              </div>
              <div className="awsui-util-container">
                <h2>
                  <a
                    href={
                      'https://i.amazon.com/issues/create?template=ec820d5a-fffa-4aaf-a336-3c7d4899aae2&customFields[string][0][id]=attemptid&customFields[string][0][value]=' + 
                      this.state.ongoingAttempt.attemptId + 
                      '&customFields[string][1][id]=challengeid&customFields[string][1][value]=' + 
                      this.state.challenge.challengeId + 
                      '&customFields[string][2][id]=domainid&customFields[string][2][value]=' + 
                      this.state.challenge.domainId + 
                      '&customFields[string][3][id]=url&customFields[string][3][value]=' + 
                      this.state.url + 
                      '&title=Report+issue+with+challenge%3A+' + 
                      this.state.challenge.challengeId + 
                      '&description=NB%3A%0APlease+ensure+that+all+the+fields+below+are+completed.%0AMake+sure+your+description+is+as+detailed+as+possible+to+better+understand+the+issue+you+are+raising'
                    }
                    target={"_blank"}
                  >
                    {" "}
                    Report issue with this challenge{" "}
                  </a>
                </h2>
              </div>

              {this.expiryNotification}
            </div>

            <div className="col-xxs-12 col-m-9 pull-m-3">
              <div className="awsui-util-container">
                <div className="awsui-util-container-header">
                  <h2>{this.state.challenge.name}</h2>
                </div>
                <div>
                  <h3>Description</h3>
                  <ReactMarkdown
                    source={this.state.challenge.description.desc}
                  />
                </div>
                <div className="awsui-util-container-footer">
                  <h3>Prerequisites</h3>
                  {this.state.challenge.prerequisites.req.map((prereq) => (
                    <ReactMarkdown source={prereq} />
                  ))}
                </div>
              </div>
              <div>
                {this.credentialsElement}
                {this.hint1Element}
                {this.hint2Element}
                <Table
                  columnDefinitions={getAttemptedChallengeTableDefinition(
                    this.props.location.pathname
                  )}
                  items={this.state.attempts.map((attempts) => ({
                    ...attempts,
                    passPercentage:
                      this.state.challenge.passPercentage === undefined
                        ? "-"
                        : this.state.challenge.passPercentage,
                  }))}
                  header={<h2>Attempts</h2>}
                  empty={
                    <div className="awsui-util-t-c">
                      <div className="awsui-util-pt-xs awsui-util-mb-xs">
                        <b>No attempts</b>
                      </div>
                      <p className="awsui-util-mb-s">No attempts found</p>
                    </div>
                  }
                ></Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualChallenge);



// WEBPACK FOOTER //
// ./src/app/components/IndividualChallenge.jsx